exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".company-header{position:sticky;top:0;z-index:3;background-color:#fff}.company-panel-header{position:sticky !important;top:52px;z-index:2}.icon-location-remove{position:absolute;right:10px;top:12px;color:inherit !important}.icon-location-remove .v-icon{color:inherit !important}", ""]);

